// CacheKey efe945d22ceb8b999ea21e4fdbf28c5f
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ASCENT": {
    data_view: {
      headers: {
        defaults: {
          comment: {
            related_encounter_id: "Visit ID"
          },
          encounter: {
            encounter_class_str: "Visit Class Str",
            encounter_id: "Visit ID",
            surgical_encounter_status: "Surgical Visit Status"
          },
          issue: {
            related_encounter_id: "Visit ID"
          }
        }
      }
    }
  }
}

